window.reactHelperComponents = [];

import React from 'react';
import { createRoot } from 'react-dom/client';
import { forEach } from 'lodash-es';

const setup = () => window.addEventListener('DOMContentLoaded', installEmbeddedComponents);

const installEmbeddedComponents = function () {
  window.reactHelperComponents = [];

  return forEach(document.querySelectorAll('[data-react-component]:not(.installed)'), (e) => {
    let component = new ReactComponent(e);
    component.install();
    window.reactHelperComponents.push(component);

    e.classList.add('installed');
  });
};

const renderReloadableComponent = function (ComponentClass, root, props = {}) {
  root.render(<ComponentClass {...props} />);
};

class ReactComponent {
  constructor(element) {
    this.element = element;
    this.componentClassName = this.element.getAttribute('data-react-component');
    this.componentProps = JSON.parse(this.element.getAttribute('data-react-props'));
  }

  async install() {
    this.componentClass = await import(`components/${this.componentClassName}.jsx`);
    // The import comes back empty when stale_bundle has cancelled its failure to reload the page
    if (!this.componentClass) return;
    if (this.componentClass.default) {
      this.componentClass = this.componentClass.default;
    }

    const root = createRoot(this.element);
    this.component = React.createElement(this.componentClass, this.componentProps);
    root.render(this.component);
  }
}

export { setup, renderReloadableComponent };
